<template >
  <div class="app">
    <span id="trylisten">we</span>
    <h5 class>典型场景降噪方案体验</h5>
    <el-tabs v-model="caseVlaue" @tab-click="clickTab">
      <el-tab-pane :key="item.value" v-for="item in cases" :label="item.label" :name="item.value"></el-tab-pane>
    </el-tabs>
    <el-carousel
      ref="carousel"
      indicator-position="none"
      :autoplay="false"
      @change="clickCarousel"
      arrow="always"
    >
      <el-carousel-item v-for="item in cases" :key="item.value" :name="item.value">
        <div class="case">
          <div class="caseimg" :style="{ background: 'url('+ item['newimg'] +') round'}"></div>
          <div class="audioo" v-loading="loadflag1">
            <audiooo
              @open="start1"
              @pause="pause1"
              @loading="load1"
              :index="item.value"
              :PlayOrPause="PlayOrPause1"
              :theUrl="item.newUrl"
              :time="item.newTime"
              v-if="!isIE"
            ></audiooo>
            <embd :theUrl="item.newUrl" :index="item.value" :PlayOrPause="PlayOrPause1" v-if="isIE"></embd>
          </div>
          <p class>处理前</p>
        </div>
        <div class="case">
          <div class="caseimg" :style="{ background: 'url('+ item['oldimg'] + ') round'}"></div>
          <div class="audioo" v-loading="loadflag2">
            <embd :theUrl="item.oldUrl" :index="item.value" :PlayOrPause="PlayOrPause2" v-if="isIE"></embd>
            <audiooo
              v-if="!isIE"
              @open="start2"
              @pause="pause2"
              @loading="load2"
              :index="item.value"
              :PlayOrPause="PlayOrPause2"
              :theUrl="item.oldUrl"
              :time="item.ordTime"
              :theControlList="item.controlList"
            />
          </div>
          <p class>处理后</p>
        </div>
      </el-carousel-item>
    </el-carousel>
    <div class="free" @click="gotofree">免费降噪体验</div>
  </div>
</template>

<script>
import audiooo from './audiooo'
import embd from './embd'
import { get, BaseURL } from '@/api/http.js'
export default {
  data () {
    return {
      cases: [],
      caseVlaue: '',
      PlayOrPause2: 'true',
      PlayOrPause1: 'true',
      // loadflag1: true,
      // loadflag2: true
      loadflag1: false,
      loadflag2: false,
      curPlayId: 0,
      isIE: false
    }
  },
  methods: {
    clickTab (val) {
      this.pauseAll()
      this.$refs.carousel.setActiveItem(val.name)
    },
    clickCarousel (newvalue, oldvalue) {
      this.pauseAll()
      this.caseVlaue = this.cases[newvalue].value
    },
    gotofree () {
      this.$router.push({
        name: 'experienceCenter',
        params: {
          ScorldId: 'toFormFree'
        }
      })
    },
    pauseAll () {
      // if (this.PlayOrPause1 === true) {
      this.PlayOrPause1 = 'false|' + this.curPlayId
      // }
      // if (this.PlayOrPause2 === true) {
      this.PlayOrPause2 = 'false|' + this.curPlayId
      // }
      this.loadflag1 = false
      this.loadflag2 = false
    },
    // 要暂停
    // "true|" + this.index
    pause2 (val) {
      let result = val.split('|')
      this.PlayOrPause2 = 'false|' + result[1]
      this.curPlayId = ''
    },
    pause1 (val) {
      let result = val.split('|')
      this.PlayOrPause1 = 'false|' + result[1]
      this.curPlayId = ''
    },
    // 要开始
    start1 (val) {
      let result = val.split('|')
      if (this.curPlayId === '') {
        this.PlayOrPause1 = 'true|' + result[1]
      } else {
        this.PlayOrPause2 = 'false|' + this.curPlayId
        this.PlayOrPause1 = 'true|' + result[1]
      }
      this.curPlayId = result[1]
    },
    // 要开始
    start2 (val) {
      let result = val.split('|')
      if (this.curPlayId === '') {
        this.PlayOrPause2 = 'true|' + result[1]
      } else {
        this.PlayOrPause1 = 'false|' + this.curPlayId
        this.PlayOrPause2 = 'true|' + result[1]
      }
      this.curPlayId = result[1]
    },
    // 正在加载
    load1 (val) {
      let result = val.split('|')
      this.curPlayId = result[1]
      if (result[0] === 'true') {
        // console.log('play1 开始加载')
        if (this.curPlayId !== '') {
          this.PlayOrPause2 = 'false|' + this.curPlayId
        }
        this.loadflag1 = true
      } else {
        this.loadflag1 = false
      }
    },
    // 正在加载
    load2 (val) {
      let result = val.split('|')
      this.curPlayId = result[1]
      if (result[0] === 'true') {
        if (this.curPlayId !== '') {
          this.PlayOrPause1 = 'false|' + this.curPlayId
        }
        this.loadflag2 = true
      } else {
        this.loadflag2 = false
      }
    },
    setProgress (percent) {
      // 根据子组件传过来的百分比设置播放进度
      this.$refs.audio.currentTime = this.currentSong.duration * percent
      // 拖动后设置歌曲播放
      if (!this.playing) {
        this.togglePlaying()
      }
    },
    getCaseImgList () {
      get('materials/listComparison', {}).then((res) => {
        if (res.success === true) {
          this.cases = []
          for (let index = 0; index < res.data.length; index++) {
            const element = res.data[index]
            let result = {}
            result['value'] = String(index)
            result['label'] = element['laber']
            result['newTime'] = Number(element['newTime']) / 1000
            result['ordTime'] = Number(element['ordTime']) / 1000
            if (this.isIE) {
              result['newUrl'] = BaseURL + 'materials/downloadWav/' + element['newWavId'] + '.wav'
              result['oldUrl'] = BaseURL + 'materials/downloadWav/' + element['ordWavId'] + '.wav'
              result['newimg'] = BaseURL + 'materials/downloadWav/' + element['newImagId'] + '.wav'
              result['oldimg'] = BaseURL + 'materials/downloadWav/' + element['ordImagId'] + '.wav'
            } else {
              result['newUrl'] = BaseURL + 'materials/download/' + element['newWavId']
              result['oldUrl'] = BaseURL + 'materials/download/' + element['ordWavId']
              result['newimg'] = BaseURL + 'materials/download/' + element['newImagId']
              result['oldimg'] = BaseURL + 'materials/download/' + element['ordImagId']
            }
            this.cases.push(result)
          }
        }
      }).catch((er) => {
        console.log(er)
      })
    },
    getWeb () {
      let userAgent = navigator.userAgent
      if ((userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0')) || ((userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1))) {
        this.wavUrl = this.theUrl
        this.isIE = true
      } else {
        this.isIE = false
      }
    }
  },
  mounted () {
    this.getWeb()
    this.caseVlaue = this.cases[0].value
  },
  created () {
    this.getCaseImgList()
  },
  watch: {
    percent () {
    },
    loadflag1 (val) {
      if (!val) {
        this.PlayOrPause1 = 'true|' + this.curPlayId
      }
    },
    loadflag2 (val) {
      if (!val) {
        this.PlayOrPause2 = 'true|' + this.curPlayId
      }
    }
  },
  computed: {
  },
  components: {
    audiooo: audiooo,
    embd
  }
}
</script>

<style  scoped>
.app {
  background-color: white;
  position: relative;
}
#trylisten {
  position: absolute;
  top: -54px;
  visibility: hidden;
}
h5 {
  width: 480px;
  height: 15px;
  font-size: 30px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  /* margin-top: -1px; */
  margin-bottom: 79px;
}

.media {
  height: 600px;
  width: 100%;
}
.progress {
  height: 200px;
  width: 100%;
}
.app /deep/ .el-carousel__container {
  position: relative;
  height: 422px;
}
.app /deep/ .el-tabs__nav {
  white-space: nowrap;
  position: relative;
  transition: -webkit-transform 0.3s;
  -webkit-transition: -webkit-transform 0.3s;
  transition: transform 0.3s;
  transition: transform 0.3s, -webkit-transform 0.3s;
  transition: transform 0.3s, -webkit-transform 0.3s;
  float: none;
  /* float: left; */
  /* text-align: center; */
  z-index: 2;
}
.app /deep/ .el-tabs__item {
  padding: 0 20px;
  height: 40px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  line-height: 40px;
  display: inline-block;
  list-style: none;
  font-size: 20px;
  font-weight: 500;
  color: #303133;
  position: relative;
}
.app /deep/ .el-tabs__active-bar {
  position: absolute;
  bottom: 0;
  left: 344px;
  height: 2px;
  /* text-align: center; */
  background: rgba(0, 0, 0, 0);
  border-radius: 5px 5px 0px 0px;
  z-index: 1;
  -webkit-transition: -webkit-transform 0.3s
    cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1),
    -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1),
    -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  list-style: none;
}
.app /deep/ .el-tabs__item.is-active {
  color: white;
  background: rgba(74, 17, 118, 1);
  border-radius: 5px 5px 0px 0px;
  padding-left: 17px;
  padding-right: 17px;
}
p {
  width: 54px;
  height: 17px;
  font-size: 18px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  margin-top: 20px;
}
/* .app /deep/ .el-tabs__item:hover {

} */
.app /deep/ .el-carousel--horizontal {
  overflow-x: hidden;
  width: 1200px;
  margin-top: -14px;
}
.app /deep/ .el-carousel__arrow {
  border: none;
  outline: 0;
  padding: 0;
  margin: 0;
  height: 56px;
  width: 56px;
  cursor: pointer;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  border-radius: 50%;
  background-color: rgba(31, 45, 61, 0.11);
  color: #fff;
  position: absolute;
  top: 50%;
  z-index: 10;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  text-align: center;
  font-size: 12px;
}
.app /deep/ .el-carousel__arrow--left {
  left: 0px;
}
.app /deep/ .el-carousel__arrow--right {
  right: 0px;
}
.case {
  height: 100%;
  float: left;
  margin-left: 120px;
  /* margin-right: 10%; */
  margin-top: 83px;
  width: 415px;
}
.audioo {
  width: 402px;
  height: 134px;
  background: rgba(252, 251, 251, 1);
  border-top-color: rgb(145, 111, 173);
  border-top-style: solid;
  border-top-width: 1px;
  border-right-color: rgb(145, 111, 173);
  border-right-style: solid;
  border-right-width: 2px;
  border-bottom-color: rgb(145, 111, 173);
  border-bottom-style: solid;
  border-bottom-width: 2px;
  border-left-color: rgb(145, 111, 173);
  border-left-style: solid;
  border-left-width: 1px;
  border-image-source: initial;
  border-image-slice: initial;
  border-image-width: initial;
  border-image-outset: initial;
  border-image-repeat: initial;
  border-radius: 4px;
  border-collapse: collapse;
}
.caseimg {
  width: 402px;
  height: 102px;
  background-size: 100% 100%;
  background-repeat: round;
  opacity: 0.7;
  border-radius: 2px;
  border: 1px solid red;
  margin-bottom: 15px;
}
.free {
  font-size: 22px;
  font-weight: normal;
  color: rgba(255, 255, 255, 1);
  width: 200px;
  height: 62px;
  line-height: 62px;
  background: rgba(74, 17, 118, 1);
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/solution/Rs/case.vue